// initial state
import * as base from './base.js'
const callcenterName = '/admin/system/record'
const statistics = callcenterName + '/statistics'
const CallSeatsEdit = '/admin/system/user/changeCall'
const callConfigEdit = '/admin/system/callConfig'
const callConfig = '/admin/system/callConfig'



const obj = base.setBaseUrl('callcenter', callcenterName)
const obj1 = base.setBaseUrl('statistics', callcenterName)
const obj2 = base.setBaseUrl('CallSeatsEdit', CallSeatsEdit)
const obj3 = base.setBaseUrl('callConfigEdit', callConfigEdit)
const obj4 = base.setBaseUrl('callConfig', callConfig)


const a = Object.assign(obj,obj1,obj2,obj3,obj4,{statistics,CallSeatsEdit,callConfigEdit,callConfig})
export default a